import { MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseMeshyMeshSimplificationProData. Builds an openedModel-shaped
 * payload from the current remeshSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseMeshyMeshSimplificationProData
 */
export const buildMeshyMeshSimplificationProFromState = (state, id) => {
  const {
    polygonType,
    targetPolycount,
  } = state.remeshSettings || {}

  return {
    id,
    providerKey: PROVIDER.MESHY,
    providerModelId: MODEL_ID.MESHY_MESH_SIMPLIFICATION_PRO,
    providerRunAttributes: {
      ...(polygonType != null && { topology: polygonType }),
      ...(targetPolycount != null && targetPolycount !== '' && { target_polycount: targetPolycount }),
    },
  }
}
